export default function isFESArea(area: string) {
  return ['FES_WARRIOR', 'FES_CHAMPION', 'FES_LEGEND', 'FES_ZOOM'].includes(area);
}
